import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {catchError} from "rxjs/operators";
import {Observable, throwError} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {InviteGuestJitsiRequest} from "../modules/meetings-workflow/models/meeting.model";

@Injectable({
  providedIn: 'root'
})
export class JitsiService {
    apiServerUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

    getCreateJitsiMeetingToken(accountId: number, roomName: string, requestBody: {
        meetingId: number;
        teamId: number;
        projectId: number;
        isOrganiser: boolean
    }) : Observable<any> {
        return this.http.post(`${this.apiServerUrl}/jitsi/token/${accountId}/${roomName}`, requestBody).pipe(
            catchError((error) => {
                return throwError(()=>error)
            }),
        );
    }

    getActiveJitsiMeeting(orgId: number, meetingKey: string): Observable<any> {
        return this.http.get(`${this.apiServerUrl}/jitsi/active-meetings`, {
            params: { orgId, meetingKey}
        }).pipe(
            catchError((error) => {
                console.log(error);
                return throwError(() => error);
            })
        );
    }

    getJitsiInviteGuestToken(request: InviteGuestJitsiRequest, accountIds: string) : Observable<any> {
        return this.http.post(`${this.apiServerUrl}/jitsi/token/guest`, request, {
            headers: {
                accountIds: accountIds,
            }
        }).pipe(
            catchError((error) => {
                return throwError(()=>error);
            }),
        );
    }

}
